<div class="panel-page-white"><div class="panel-white body-2" :class="panelClass"><slot></slot></div></div>